import React from "react";
import { useNavigate } from "react-router-dom";
import loadingImage from "../assets/Loading.png"; // Ensure correct image path
import "./LoadingScreen.css"; // Import external CSS

const LoadingScreen = () => {
  const navigate = useNavigate();

  const handleNavigate = () => {
    navigate("/dashboard"); // Change the path to your target route
  };

  return (
    <div className="loading-container">
      <div className="loading-content">
        <img src={loadingImage} alt="Loading" className="loading-image" />

        {/* Updated: Black "Loading ..." */}
        <h1 className="loading-title">Loading ...</h1>

        {/* Updated: Background color for description */}
        <p className="loading-description">
          Please wait a moment, we are processing your request.
        </p>
      </div>
    </div>
  );
};

export default LoadingScreen;
